var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"title-warp"},_vm._l((_vm.Titles),function(item,idx){return _c('div',{key:idx,staticClass:"title-box"},[_c('h3',{staticClass:"title one-line"},[_vm._v(_vm._s(item.Content))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a8a7e16","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/template/title/StartStop.vue
// module id = null
// module chunks = 